<div class="applink-container"
    *ngIf="storeConfig?.showStore && !storeConfig?.isDesktop && (restaurantInfo?.showAndroidStore ||  restaurantInfo?.showIosStore)">
    <button type="button" class="close" (click)="storeConfig.showStore =! storeConfig.showStore" aria-label="Close app banner">
        <span aria-hidden="true">&times;</span>
    </button>
    <div class="app-icon">
        <div class="image-wrap">
            <figure><img [src]="restaurantInfo?.logo || '../../../../assets/images/logo.png'" [alt]="(restaurantInfo?.name || clientConfig?.title || 'Restaurant') + ' Logo'"></figure>
        </div>
    </div>
    <div class="applink-bar pull-left">
        <span id="spnHeaderMsg">Download our app for faster experience!</span>
    </div>
    <div id="storeIcon" class="store-icon pull-right">
        <a *ngIf="!storeConfig?.isAndroid" href="{{restaurantInfo?.iosAppLink}}" target="_blank" rel="noopener noreferrer" aria-label="Download on the App Store (opens in a new window)"><img
                src="../../../../assets/images/AppStore.png" alt="App Store"></a>
        <a *ngIf="storeConfig?.isAndroid" href="{{restaurantInfo?.androidAppLink}}" target="_blank" rel="noopener noreferrer" aria-label="Get it on Google Play (opens in a new window)"><img
                src="../../../../assets/images/PlayStore.png" alt="Google Play Store"></a>
    </div>
</div>
<header class="dv-header" [ngStyle]="clientConfig?.style?.bg">
    <div class="container">
        <div class="header-in">
            <button type="button" (click)="showMenu =! showMenu" class="hamburger-menu" aria-label="Toggle navigation menu" [attr.aria-expanded]="showMenu">
                <i id="toggle" class="fas fa-bars toggle" aria-hidden="true"></i>
            </button>

            <div class="home-menu">
                <img [src]="restaurantInfo?.logo || '../../../../assets/images/logo.png'" [alt]="(restaurantInfo?.name || clientConfig?.title || 'Restaurant') + ' Logo'"
                    class="header-logo" />
            </div>
            <div class="restro-name login-menu">
                <img [src]="restaurantInfo?.logo || '../../../../assets/images/logo.png'" [alt]="(restaurantInfo?.name || clientConfig?.title || 'Restaurant') + ' Logo'"
                    class="header-logo" />
            </div>

            <!-- <div class="restro-name text-center">{{clientConfig?.title}}</div> -->
            <nav aria-label="Main Navigation">
                <ul [style.background-color]="showMenu ? clientConfig?.color : null" class="left-menu"
                    [ngClass]="{'active': showMenu}">
                    <li class="menu-0"> <a (click)="showMenu=false" routerLink="/home">Home</a></li>
                    <li class="menu-0" [routerLinkActive]="['active']"> <a (click)="showMenu=false"
                            routerLink="/home/about-us">About Us</a>
                    </li>
                    <li *ngIf="isOutletSelected && outletFeatures?.event" class="menu-0" [routerLinkActive]="['active']"><a
                            (click)="showMenu=false" [routerLink]="['/home/events']">Events</a>
                    </li>
                    <li *ngIf="isOutletSelected" class="menu-0" [routerLinkActive]="['active']"><a (click)="showMenu=false"
                            [routerLink]="['/home/menu']">Our
                            Menu</a>
                    </li>
                    <li *ngIf="isOutletSelected && outletFeatures?.coupon" class="menu-0" [routerLinkActive]="['active']"><a
                            (click)="showMenu=false" [routerLink]="['/home/coupons']">Coupons</a>
                    </li>
                    <li *ngIf="isOutletSelected && outletFeatures?.tableBooking" class="menu-5"
                        [routerLinkActive]="['active']"><a (click)="showMenu=false"
                            [routerLink]="['/home/reservation']">Reservation</a></li>
                    <li *ngIf="isOutletSelected && outletFeatures?.giftCard" class="menu-5" [routerLinkActive]="['active']">
                        <a (click)="showMenu=false" [routerLink]="['/giftcard']">Gift Cards</a>
                    </li>
                    <li *ngIf="isLoggedIn" class="menu-0" [routerLinkActive]="['active']"><a (click)="showMenu=false"
                            [routerLink]="['/home/orders']">My
                            Order</a></li>
                    <li *ngIf="isLoggedIn && restaurantInfo?.isRewardPoints" class="menu-0" [routerLinkActive]="['active']">
                        <a (click)="showMenu=false" [routerLink]="['/home/rewards']">My
                            Rewards</a>
                    </li>
                    <li [hidden]="isLoggedIn" class="menu-0 login-menu" [routerLinkActive]="['active']"> <a
                            (click)="showMenu=false; openLoginDialog()" role="button" tabindex="0" (keydown.enter)="showMenu=false; openLoginDialog()" (keydown.space)="showMenu=false; openLoginDialog(); $event.preventDefault()" aria-label="Sign In">Sign In</a>
                    </li>
                </ul>
            </nav>
            <div class="right-menu">
                <span class="icon-cst" *ngIf="restaurantInfo?.showFacebook">
                    <a class="fb-clr" [ngStyle]="clientConfig?.style?.color" target="_blank" rel="noopener noreferrer"
                        [href]="restaurantInfo?.facebookLink" aria-label="Visit our Facebook page (opens in new window)"><i class="fa fa-facebook toggle" aria-hidden="true"></i></a>
                </span>

                <span class="icon-cst">
                    <button type="button" class="fb-clr btn-header-icon" [ngStyle]="clientConfig?.style?.color"
                        (click)="navigateCart()" aria-label="View shopping cart">
                        <i class="fas fa-shopping-cart" aria-hidden="true"></i>
                    </button>
                </span>

                <span class="icon-cst" *ngIf="!isLoggedIn">
                    <button type="button" class="fb-clr btn-header-icon" [ngStyle]="clientConfig?.style?.color"
                        (click)="openLoginDialog()" aria-label="Sign in to your account">
                        <i class="fas fa-user" aria-hidden="true"></i>
                    </button>
                </span>
                <ul class="nav navbar-nav showingname-info" *ngIf="isLoggedIn">
                    <li class="dropdown">
                        <a class="dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false" [attr.aria-label]="'Account menu for ' + (currentUser?.fullName || 'user')"><i class="fas fa-user" aria-hidden="true"></i></a>
                        <ul class="dropdown-menu">
                            <li class="user-name-label">{{currentUser?.fullName}}</li>
                            <li [hidden]="restaurantInfo?.isOtpLogin"><a role="button" tabindex="0"
                                    (click)="changePassword()" (keydown.enter)="changePassword()" aria-label="Change Password">Change Password</a></li>
                            <li><a routerLink="/auth/profile" aria-label="My Profile">My Profile</a></li>
                            <li><a routerLink="/home/address" aria-label="My Addresses">My Addresses</a></li>
                            <li><a role="button" tabindex="0" (click)="logOut()" (keydown.enter)="logOut()" aria-label="Logout">Logout</a></li>
                        </ul>
                    </li>
                </ul>
            </div>

        </div>
    </div>
</header>

<!-- <div *ngIf="!initialized"
    style="position: fixed; width: 100%; height: 100%; background-color: gray; z-index: 30001; opacity: 10;">
    <p style="position: absolute; top: 30%; left: 45%;">
        <img src="../../../../assets/images/loader.gif" alt="loading" style="width:100px; height:100px;" />
    </p>
</div> -->